<template>
<div class="modal fade" id="audioFrModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLabel">CHARGEMENT DU PITCH EN FRANCAIS</h6>
                <button type="button" class="btn-close" data-bs-dismiss="modal" id="close33" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form class="form" @submit.prevent="submit" >
                    
                    <div class="form-group mb-2">
                            <label for="">FICHIER EN FRANCAIS</label>
                            <input type="file" class="form-control" name="file_fr" id="file_fr" @change="fileChangeFr">
                        </div>
                       <button class="btn btn-success" type="submit">ENREGISTRER</button>
                 </form>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from "axios";
import { createToaster } from "@meforma/vue-toaster";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    export default{
        name:'EvolutionComponent',
        props:{
            dossier:{
                'type':Object,
                'required':true,
            }
        },
        data(){
            return {
                presentation_evolution_marche:this.dossier.presentation_evolution_marche,
                editor: ClassicEditor,
                editorConfig: this.editorConfig,
                file_fr:null,
                toaster: createToaster({ position:'top-right'}),

            }
        },
        methods:{
            fileChangeFr(event){
                this.file_fr = event.target.files[0];
            },
            submit(){
                document.getElementById('close33').click();
                let loader = this.$loading.show({
                    container: this.fullPage ? null : this.$refs.formContainer,
                    canCancel: false,
                });
                let form = new FormData();
                if(this.file_fr!=null){
                    form.append("file_fr",this.file_fr);
                }
                form.append("token",this.dossier.token);
                axios.post('/audio/ic4a/pmes/podcasts',form,{
                    headers:{
                        'Accept':'multipart/form-data',
                    }
                })
                .then((res)=>{
                    console.log(res)
                    //let rp = {token:this.dossier.token,fr:res.data.fr};
                    axios.post(this.path+'consultant/pme/audio/path',res.data)
                    .then(()=>{
                        console.log(res)
                        this.$emit('ended');
                    })
                    .catch((err)=>{
                        this.toaster.error("Une erreur est survenue lors de l'enregistrement !");
                        console.log(err)
                    })
                    .finally(()=>loader.hide())
                })
                .catch((err)=>{
                    this.toaster.error("Une erreur est survenue lors de l'enregistrement !");
                    console.log(err)
                })
                .finally(()=>loader.hide())
            }
        }
    }

</script>

<style scoped>


</style>